import { 
  FETCH_EQUIPMENT_DATA,
  FETCH_EQUIPMENT_DATA_SUCCESS,
  FETCH_EQUIPMENT_DATA_FAILURE,
  FETCH_CONSUMABLES_DATA,
  FETCH_CONSUMABLES_DATA_SUCCESS,
  FETCH_CONSUMABLES_DATA_FAILURE,
  FETCH_QC_INSPECTION_PERSONNEL_DATA,
  FETCH_QC_INSPECTION_PERSONNEL_DATA_SUCCESS,
  FETCH_QC_INSPECTION_PERSONNEL_DATA_FAILURE,
  REFRESH_EQUIPMENT_DATA,
  REFRESH_CONSUMABLES_DATA,
  REFRESH_QC_INSPECTION_PERSONNEL_DATA,
  FETCH_REGISTRY_MISCELLANEOUS_DATA,
  FETCH_REGISTRY_MISCELLANEOUS_DATA_SUCCESS,
  FETCH_REGISTRY_MISCELLANEOUS_DATA_FAILURE,
  REFRESH_REGISTRY_MISCELLANEOUS_DATA,
} from "./types";

// Equipment Actions
export const fetchEquipmentData = (payload) => ({
  type: FETCH_EQUIPMENT_DATA,
  payload
});

export const fetchEquipmentDataSuccess = (payload) => ({
  type: FETCH_EQUIPMENT_DATA_SUCCESS,
  payload
});

export const fetchEquipmentDataFailure = (error) => ({
  type: FETCH_EQUIPMENT_DATA_FAILURE,
  error
});

// Consumables Actions
export const fetchConsumablesData = (payload) => ({
  type: FETCH_CONSUMABLES_DATA,
  payload
});

export const fetchConsumablesDataSuccess = (payload) => ({
  type: FETCH_CONSUMABLES_DATA_SUCCESS,
  payload
});

export const fetchConsumablesDataFailure = (error) => ({
  type: FETCH_CONSUMABLES_DATA_FAILURE,
  error
});

// QC Inspection Personnel Actions
export const fetchInspectionPersonnelData = (payload) => ({
  type: FETCH_QC_INSPECTION_PERSONNEL_DATA,
  payload
});

export const fetchInspectionPersonnelDataSuccess = (payload) => ({
  type: FETCH_QC_INSPECTION_PERSONNEL_DATA_SUCCESS,
  payload
});

export const fetchInspectionPersonnelDataFailure = (error) => ({
  type: FETCH_QC_INSPECTION_PERSONNEL_DATA_FAILURE,
  error
});

// Refresh Actions
export const refreshEquipmentData = (payload) => ({
  type: REFRESH_EQUIPMENT_DATA,
  payload
});

export const refreshConsumablesData = (payload) => ({
  type: REFRESH_CONSUMABLES_DATA,
  payload
});

export const refreshQCInspectionPersonnelData = (payload) => ({
  type: REFRESH_QC_INSPECTION_PERSONNEL_DATA,
  payload
});

export const fetchRegistryMiscellaneousData = (payload) => ({
  type: FETCH_REGISTRY_MISCELLANEOUS_DATA,
  payload,
});

export const fetchRegistryMiscellaneousDataSuccess = (payload) => ({
  type: FETCH_REGISTRY_MISCELLANEOUS_DATA_SUCCESS,
  payload,
});

export const fetchRegistryMiscellaneousDataFailure = (error) => ({
  type: FETCH_REGISTRY_MISCELLANEOUS_DATA_FAILURE,
  error,
});

export const refreshRegistryMiscellaneousData = (payload) => ({
  type: REFRESH_REGISTRY_MISCELLANEOUS_DATA,
  payload,
});

